import styled from 'styled-components'

import { colors, ErrorSvg, Icon } from '@spritz-finance/ui'
import { cssVar } from '../../theme/utils'

export const ErrorMessageContainer = styled.div`
    color: var(--text-error, ${colors.orchid});
    font-family: inherit;
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    display: inline-flex;
    align-items: center;
    width: 100%;
    margin-top: 5px;
    margin-bottom: 5px;
`

export const ErrorIcon = () => (
    <Icon tint={cssVar('--text-error', colors.orchid)} icon={ErrorSvg} size={24} />
)

export const ErrorMessageText = styled.p`
    margin: 0;
`
